import { css } from "@emotion/react";
import { breakpoints } from "@mytutor/shared-react-web-components/lib/theme";
import {
  staticSubjectsData,
  StaticSubjectsData,
} from "../../util/data/subjects";
import { staticLevelsData, StaticLevelsData } from "../../util/data/levels";

const getSubjectName = (data: StaticSubjectsData, urlValue: string) => {
  return data
    .filter((subject) => subject.urlSubject === urlValue)
    .map((subject) => subject.subject)[0];
};
const getLevelName = (data: StaticLevelsData, urlValue: string) => {
  return data
    .filter((level) => level.urlLevel === urlValue)
    .map((level) => level.level)[0];
};

const getSubjectSyntax = (currentSubject: string) => {
  return currentSubject ? currentSubject + " " : "";
};

const getAdditionalSubjectSyntax = (currentAdditionalSubject: string) => {
  return currentAdditionalSubject
    ? "and " + currentAdditionalSubject + " "
    : "";
};

const getLevelSyntax = (currentLevel: string) => {
  return currentLevel ? currentLevel + " " : "";
};

const AvailableTutors = ({
  paginationData,
  subjectAndLevel,
  urlParameters,
}) => {
  const tutorCardStyle = css`
    h2 {
      font-size: 28px;
      line-height: 28px;
      font-weight: 500;
      margin: 24px 0px;
      padding: 0px 20px;
      @media (min-width: ${breakpoints.tablet}px) {
        margin-bottom: 32px;
        padding: 0px;
      }
      @media (min-width: ${breakpoints.desktop}px) {
        margin-bottom: 42px;
        font-size: 32px;
      }
    }
  `;

  const numberOfTutors = paginationData ? paginationData.totalSize : "0";
  let subject = "";
  let additionalSubject = "";
  let level = "";
  if (subjectAndLevel.subject) {
    const subjectName = getSubjectName(
      staticSubjectsData,
      subjectAndLevel.subject
    );
    subject = getSubjectSyntax(subjectName);
  }
  if (subjectAndLevel.subject && urlParameters.additionalSubject) {
    const additionalSubjectName = getSubjectName(
      staticSubjectsData,
      urlParameters.additionalSubject
    );
    additionalSubject = getAdditionalSubjectSyntax(additionalSubjectName);
  }
  if (subjectAndLevel.level) {
    const levelName = getLevelName(staticLevelsData, subjectAndLevel.level);
    level = getLevelSyntax(levelName);
  }
  return (
    <div className="row" css={tutorCardStyle}>
      {numberOfTutors === 0 && (
        <h2>
          We couldn&apos;t find any {level}
          {subject}
          {additionalSubject}tutors that match your search
        </h2>
      )}
    </div>
  );
};

export default AvailableTutors;
